module.exports = __webpack_public_path__ + "img/1@3x.b33a51a4.png";